import { all, call, select, take } from 'redux-saga/effects';

function* getProductPending() {
    const productUpdate = yield take('product:update');
    return productUpdate.payload.pending;
}

export function* waitForPendingProduct() {
    const [user_uuid, product_uuid] = yield all([
        select(state => state.user && state.user.member_uuid),
        select(state => state.product && state.product.member_uuid),
    ]);

    // only allow pending products to be submitted by the same user
    if (user_uuid && product_uuid && user_uuid != product_uuid) {
        // refresh page without the ?report param if user is not the same
        const { origin, pathname } = window.location;
        const newLocation = new URL(`${origin}${pathname}`);
        window.location.href = newLocation.href;

        return;
    }

    const pending = yield select(state => state.product.pending);
    if (pending) {
        const nextRoute = yield take('route:to');
        if (nextRoute.payload == 'sms') {
            // wait for sms modal close
            let productPending = true;
            while (productPending) {
                productPending = yield call(getProductPending);
            }
        }
    }
}
